import mapProps from 'recompose/mapProps';
import PayPal from './PayPal';
import get from 'lodash/get';
import linkFactory from '../../../../analytics/factory/link';

const enhance = mapProps(({ paymentMethods, ...props }) => {
  const paypal = paymentMethods.find(method => method.id === 'paypal_checkout');
  const url = get(paypal, 'url', '');
  return {
    ...props,
    url,
    onClick: linkFactory({
      href: url,
      category: 'Cart',
      action: 'Pay With PayPal Checkout',
      label: 'PayPal Checkout',
    })
  };
});

export default enhance(PayPal);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/PayPal/index.js